
var finansudd = finansudd || {};

finansudd.trigger = new function(){

    var self = this;

    this.init = function () {

    	$('[data-trigger]').click(function(e) {
    		// Get the ID of the data-trigger target
    		var selector = $($(this).attr('data-trigger'));

    		e.preventDefault();
    		selector.toggle();

    	});

	};

};